import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { round } from 'lodash';
import { Message } from 'primeng/api';
import { breadcrumb, link, stat } from 'src/app/admin/layout/header/header.component';
import { MenuItem } from 'src/app/misc/interface/menu-item';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-bulk-results',
  templateUrl: './bulk-results.component.html',
  styleUrl: './bulk-results.component.scss'
})


export class BulkResultsComponent {

  messages: Message[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
      }
    }
  ];

  colors = ["#002060", "#0070c0", "#00b0f0", "#7030a0"];

  header = this.translate('Assessment Results');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-angle-right',
      link: '/assessment',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Assessments'), link: '/assessment' },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  alldata: any;
  topStats: any;
  totalGrades: any;

  options: any;
  options2: any;

  totalGradesData : any;

  mistakersPercentage = 0;

  // Custom tooltip function
  customTooltip = (context: any) => {
    // Context contains information about the hovered data point
    const { dataIndex } = context;
    const value = this.totalGradesData.datasets[0].data[dataIndex];
    return `Value: ${value}`; // Customize this as per your requirement
  };
  criterias: any;
  totalQuestionsData: any;
  totalQuestionsDataGraph: any;
  worstPerformingQuestions: any;
  assessmentIds: any;


  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private dataService: DataService,
  ) {}


  ngOnInit() {
    this.activatedRouter.queryParams.subscribe(async params => {
      if(params['ids']) {

        const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

        this.assessmentIds = params['ids'];


        this.breadcrumbs.push({ name: this.translate('Assessment Results'), link: '/assessment/all-results?' + queryString  });


      } else {
        this.router.navigate(['/assessment']);
      }
    })
  }

   translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

}
